import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { ModalPropType } from '@ocean/ui/dist/components/modals/common/types'
import { useLazySelector, useInitialLoading } from 'hooks'
import { InstructorPicker } from 'modules/simulatorTrainings/common/components'
import { loadSpecialUsersData } from 'modules/simulatorTrainings/common/slices/instructor'
import { SpecialUser } from 'modules/simulatorTrainings/common/types'

type InstructorPickerContainerProps = Pick<ModalPropType, 'onClose' | 'isOpen'> & {
  onSubmit: (instructor: Record<string, SpecialUser>) => void
  addedInstructorIds?: string[]
  canBeAddedCount?: number
}

const InstructorPickerContainer: React.FC<InstructorPickerContainerProps> = props => {
  const dispatch = useDispatch()
  const { onClose, onSubmit, isOpen, addedInstructorIds, canBeAddedCount } = props

  const { instructors, error, isLoading } = useLazySelector(({ simulatorTrainingInstructor }) => {
    const { result, isLoading, error } = simulatorTrainingInstructor.instructors

    return {
      instructors: result?.list.instructors,
      isLoading,
      error,
    }
  })
  const isInitialLoading = useInitialLoading(isLoading)

  useEffect(() => {
    isOpen && dispatch(loadSpecialUsersData())
  }, [dispatch, isOpen])

  return (
    <InstructorPicker
      isLoading={isInitialLoading}
      error={error}
      data={instructors}
      addedInstructorIds={addedInstructorIds}
      canBeAddedCount={canBeAddedCount}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={onSubmit}
    />
  )
}

export default InstructorPickerContainer
